import type { MouseEventHandler } from 'react'

type BoxMouseEvent = Parameters<MouseEventHandler<HTMLDivElement>>[0]

type KeyboardActivationEvent = {
	key: string
	defaultPrevented: boolean
	preventDefault: () => void
	currentTarget: { click: () => void }
}

export type BoxClickHandler<Event = BoxMouseEvent> = (
	event: Event
) => Promise<unknown> | unknown

export function runBoxClick<Event>({
	event,
	onClick,
	isLoading,
	setAsyncLoading
}: {
	event: Event
	onClick?: (event: Event) => Promise<unknown> | unknown
	isLoading: boolean
	setAsyncLoading: (value: boolean) => void
}) {
	if (onClick == null || isLoading) return

	const result = onClick(event)
	if (result instanceof Promise) {
		setAsyncLoading(true)
		result.finally(() => setAsyncLoading(false))
	}
	return result
}

export function runBoxKeyboardActivation<
	Event extends KeyboardActivationEvent
>({
	event,
	isClickable,
	isLoading,
	onKeyDown
}: {
	event: Event
	isClickable: boolean
	isLoading: boolean
	onKeyDown?: (event: Event) => void
}) {
	onKeyDown?.(event)
	if (!isClickable || isLoading || event.defaultPrevented) return
	if (event.key !== 'Enter' && event.key !== ' ') return

	event.preventDefault()
	event.currentTarget.click()
}
